import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiBaseResponse, CommonDropdown, PageData } from '../../../models';
import { map, debounceTime } from 'rxjs/operators';

@Injectable()
export class BidIncrementService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getIncrementsInDD(auctionStatus: number): Observable<CommonDropdown[]> {
    return this.http
      .get<ApiBaseResponse<CommonDropdown[]>>(
        `${this.apiUrl}/bidIncrements/dropDownList`,
        {
          params: {
            auctionStatus: auctionStatus + '',
          },
        }
      )
      .pipe(map((it) => it.data));
  }

  getIncrementList(
    pageNumber: number,
    pageSize: number
  ): Observable<PageData<BidIncrementInList[]>> {
    let param = new HttpParams();
    param = param.append('pageNumber', pageNumber.toString());
    param = param.append('pageSize', pageSize.toString());
    param = param.append('isPaginated', true + '');
    return this.http
      .get<ApiBaseResponse<BidIncrementInList[]>>(
        `${this.apiUrl}/bidIncrements/getAll`,
        {
          params: param,
        }
      )
      .pipe(
        map((it) => ({ data: it.data, totalCount: it.pagingInfo.totalCount }))
      );
  }

  addEditIncrement(model: BidIncrement): Observable<BidIncrementInList> {
    return this.http
      .post<ApiBaseResponse<BidIncrementInList>>(
        `${this.apiUrl}/bidIncrements/addEdit`,
        model
      )
      .pipe(map((it) => it.data));
  }

  getBidIncrement(IncId: number): Observable<BidIncrementInList> {
    return this.http
      .get<ApiBaseResponse<BidIncrementInList>>(
        `${this.apiUrl}/bidIncrements/getById`,
        {
          params: {
            id: IncId.toString(),
          },
        }
      )
      .pipe(map((it) => it.data));
  }

  changeStatusOfInc(IncId: number): Observable<BidIncrementInList> {
    return this.http
      .post<ApiBaseResponse<BidIncrementInList>>(
        `${this.apiUrl}/bidIncrements/changeStatus`,
        { id: IncId }
      )
      .pipe(map((it) => it.data));
  }

  markAnIncAsDefault(IncId: number): Observable<BidIncrementInList> {
    return this.http
      .post<ApiBaseResponse<BidIncrementInList>>(
        `${this.apiUrl}/bidIncrements/markAsDefault`,
        { id: IncId }
      )
      .pipe(map((it) => it.data));
  }

  checkNameUnique(title: string): Promise<boolean> {
    return this.http
      .get<ApiBaseResponse<boolean>>(
        `${this.apiUrl}/bidIncrements/isNameUnique`,
        {
          params: {
            title: title,
          },
        }
      )
      .pipe(
        debounceTime(500),
        map((it) => it.data)
      )
      .toPromise();
  }

  checkIncrementOptions(incId: number): Observable<any> {
    return this.http
      .get<ApiBaseResponse<any>>(`${this.apiUrl}/bidIncrements/CheckActions`, {
        params: {
          id: '' + incId,
        },
      })
      .pipe(map((it) => it.data));
  }
}

export interface BidIncrement {
  id: number;
  name: string;
  isDefault: boolean;
  bidIncrementSlabs: Array<Slab>;
}

export interface Slab {
  id: number;
  minValue: number;
  maxValue: number;
  increment: number;
  lastUpdatedOn?: string;
}

export interface BidIncrementInList {
  id: number;
  name: string;
  isDefault: boolean;
  isActive: boolean;
  isNonEditable: boolean;
  isNonDeactivatable: boolean;
  auctions: Array<number>;
  lastUpdatedOn: string;
  bidIncrementResponseSlabs: Array<Slab>;
}
